import { nanoid } from '@reduxjs/toolkit';
import { CircleCheckBig } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Skeleton } from 'ui';
import Button from 'ui/components/Button';
import { clearPendingTask, getMostRecentCommentId, setCreateModalOpen, setGeneralTaskModalOpen, setPendingTask, setSelectedTask, setSelectedTaskId, setShouldShowSkeleton } from '../../../store/tasksSlice';
import { getIsBottomBarLoading } from '../../../store/uiSlice';
import { GeneralTaskModal } from '../../modals/general-task/general-task-modal';

export const GeneralTask = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const pendingTaskId = `PENDING-${nanoid(6)}`;
  const mostRecentComment = useSelector(getMostRecentCommentId);
  const isBottomBarLoading = useSelector(getIsBottomBarLoading);
  const handleGeneralTaskClick = () => {
    dispatch(setShouldShowSkeleton(false));
    dispatch(setCreateModalOpen(false));
    dispatch(setGeneralTaskModalOpen(true));
    dispatch(setSelectedTaskId(pendingTaskId));
    dispatch(setSelectedTask(undefined))
    dispatch(clearPendingTask());
    dispatch(
      setPendingTask({
        task_element_path: '',
        task_comment_id: mostRecentComment + 1,
        task_priority: 'low',
        task_status: 'open',
        task_id: pendingTaskId,
        is_internal: false,
        screenshot: '',
      })
    );
  };


  return (
    <>
      {isBottomBarLoading ? (
        <Skeleton className="h-9 w-9 rounded-md" />
      ) : (
        <>
          <Button
            size="icon"
            variant="outline"
            leftIcon={<CircleCheckBig size={18} />}
            onClick={handleGeneralTaskClick}
            tooltip={t('bottom_bar.general_task_tooltip', 'Create a task linked to this page, not tied to a specific element')}
            tooltipSide="top"
            className='hidden md:flex'
          ></Button>

          <GeneralTaskModal />
        </>
      )}

    </>
  );
};


